<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">客服</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="9" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r fs18 col04 tc">
                <div>客服电话：{{tel}}</div>
                <div>任何问题可致电与我们咨询</div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "客服-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            tel: ''
        };
    },
    created(){
        this.$api.ConfigInit().then(ret=>{
          this.tel = ret.data.app.tel;
        })
    },
    methods: {

    },
};
</script>

<style lang="less" scoped>
.part_r {
    background: #fff;
    padding-top: 44px;
    line-height: 38px;
}
</style>
